module.exports = __webpack_public_path__ + "img/logo-light.2745a15.svg";